import SEO from '../../../components/base/SEO';
import Header from './components/Header';
import Hero from './components/Hero';
import TopCards from './components/TopCards';
import ReturnMechanism from './components/ReturnMechanism';
import WhoShouldUse from './components/WhoShouldUse';
import Cautions from './components/Cautions';
import Footer from './components/Footer';
import Breadcrumb from '../../../components/feature/Breadcrumb';

export default function HighReturnRateArticlePage() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Article',
        headline: '高還元率クレジットカード徹底比較｜1.0%以上のおすすめカード',
        description: '還元率1.0%以上の高還元率クレジットカードを徹底比較。リクルートカード1.2%、大手ECモール系カード1.0%など、ポイントが貯まりやすいカードの選び方と活用法を詳しく解説します。',
        author: {
          '@type': 'Organization',
          name: 'クレジットカード比較'
        },
        datePublished: '2026-01-01',
        dateModified: new Date().toISOString().split('T')[0],
        image: 'https://public.readdy.ai/ai/img_res/c9bdd72f96677fbf377a3dd1b32e6b17.jpg'
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'ホーム',
            item: 'https://yourdomain.com/'
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '記事一覧',
            item: 'https://yourdomain.com/#articles'
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: '高還元率クレジットカード',
            item: 'https://yourdomain.com/articles/high-return-rate'
          }
        ]
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="高還元率クレジットカード徹底比較｜1.0%以上のおすすめカード"
        description="還元率1.0%以上の高還元率クレジットカードを徹底比較。リクルートカード1.2%、大手ECモール系カード1.0%など、ポイントが貯まりやすいカードの選び方と活用法を詳しく解説します。"
        keywords="クレジットカード,高還元率,ポイント還元,1.0%以上,リクルートカード,大手ECモール系カード,お得"
        canonicalUrl="https://yourdomain.com/articles/high-return-rate"
        ogImage="https://readdy.ai/api/search-image?query=premium%20credit%20cards%20with%20high%20cashback%20percentage%20symbols%20modern%20design%20on%20clean%20white%20background%20professional%20product%20photography%20high%20quality%20detailed%20sharp%20focus&width=1200&height=630&seq=high-return-og&orientation=landscape"
        structuredData={structuredData}
      />
      <Header />
      <Breadcrumb items={[
        { label: 'ホーム', path: '/' },
        { label: '記事一覧', path: '/#articles' },
        { label: '高還元率クレジットカード' }
      ]} />
      <Hero />
      <TopCards />
      <ReturnMechanism />
      <WhoShouldUse />
      <Cautions />
      <Footer />
    </div>
  );
}
